import Layout from '../components/layout/Layout';

const AdoptablesPage = () => {
  return (
    <Layout>
      <div className="py-12">
        <div className="container-custom text-center max-w-lg mx-auto">
          <h1 className="text-2xl font-bold text-gray-900 dark:text-white">Adoptables</h1>
          <p className="mt-4 text-gray-600 dark:text-gray-400">
            Aún no disponible. Estamos trabajando en ello.
          </p>
        </div>
      </div>
    </Layout>
  );
};

export default AdoptablesPage;
